import axios from "../helper/axios";

export function NuJobsSignup(data, callback) {
  return async (dispatch) => {
    try {
      //console.log("nujobsusersignup:", data);
      const response = await axios.post("/nujobsusersignup", data, {
        _ignoreLoading: true,
      });

      // Dispatch({ type: "SIGNUP", payload: response.data });
      callback(null, "success"); // Pass null or undefined in the success case
    } catch (error) {
      console.error("Signup error:", error);
      if (error.response && error.response.data && error.response.data.error) {
        console.error("Server error:", error.response.data.error);
        localStorage.setItem("errormessage", error.response.data.error);
        callback(error.response.data.error, "error");
      } else {
        console.error("Unknown error occurred");
        localStorage.setItem("errormessage", "Unknown error occurred");
        callback("Unknown error occurred", "error");
      }
    }
  };
}

export function NuJobsVerifyAccountOtp(data,callback) {
  //console.log("/users/verifyaccount",data)
  return async (Dispatch) => {
    axios
      .post("/nujobsverifyaccountotp", data, { _ignoreLoading: true })
      .then((res) => {
        //console.log(res);
        Dispatch({ type: "SIGNUP", payload: res });
        localStorage.setItem("nujobsUserDetails",JSON.stringify(res.data.user))
        localStorage.setItem("userDetails",null)
        Dispatch({ type: "SIGNIN", payload: res.data.user });
       callback()
      })
      .catch((e) => console.log(e));
  };
}

export function NuJobsSignIn(data, callback) {
  return async (dispatch) => {
    try {

      const response = await axios.post("/nujobssignin", data, {
        _ignoreLoading: true,
      });
      //console.log("/users/getotp", response.data);
      callback(null, "success"); // Pass null or undefined in the success case
    } catch (error) {
      console.error(error);
      console.error(error.response.data.error);
      localStorage.setItem("errormessage", error.response.data.error);
      callback(error.response.data.error, "error");
    }
  };
}

export function NuJobsResendOTP(data, callback) {
  return async (Dispatch) => {
    try {
      //console.log("ResendOTP Data", data);
      const response = await axios.post("/nujobsresendotp", data, {
        _ignoreLoading: true,
      });
      //console.log("/users/resendotp", response.data);
      callback(null, "success");
    } catch (e) {
      console.log(e);
      callback(e.message, "Resend OTP Failed");
    }
  };
}

export function NuJobsVerifySignInOtp(data, callback) {
  console.log("/nujobsverifysigninotp", data);
  return async (Dispatch) => {
    axios
      .post("/nujobsverifysigninotp", data, { _ignoreLoading: true })
      .then((res) => {
        localStorage.setItem("nujobsUserDetails",JSON.stringify(res.data.user))
        localStorage.setItem("userDetails",null)
        Dispatch({ type: "SIGNIN", payload: res.data.user });
        callback(null, "success");
      })
      .catch((e) => {
        console.log("This is the error that im looking at");
        callback(e.response.data.error, "Still Dont know the error");
      });
  };
}


export function NuJobsLogout(data,callback) {
  console.log("log out called",data)
  return async (Dispatch) => {
    axios
      .post("/nujobslogout/")  
      .then((res) => {
        console.log(res)
        localStorage.removeItem("token")
        Dispatch({ type: "LOGOUT", payload: res.data });
        callback()
      })
      .catch((e) => console.log(e));
  };
}
